<div class="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
  <div class="p-5 space-y-4">
    <h1
      class="mb-2 text-2xl font-bold leading-tight tracking-tight text-gray-900 text-center">
      Save a payment method
    </h1>
    <div
      class="flex items-center text-base text-primary-800 bg-primary-100 py-3 px-5 rounded-lg flex gap-2 leading-[120%]">
      <icaredx-display-avatar
        [profileImageUrl]="''"
        [givenName]="providerNameSplited.givenName"
        [familyName]="providerNameSplited.familyName">
      </icaredx-display-avatar>
      <div>
        To hold your appointment with
        <span class="font-semibold">{{ provider()!.providerName }}</span
        >, add a card or bank account now. You will not be charged today.
      </div>
    </div>
    <div class="border border-gray-200 p-6 leading-[150%] space-y-4">
      <div>
        <h3 class="font-semibold text-xl text-gray-900">What happens next</h3>
        <p class="mt-2 text-sm text-gray-600">
          Stripe will securely save your payment method for this booking. The
          practice can charge it after your visit if payment is still due.
        </p>
      </div>

      <div class="border border-gray-200 rounded-lg p-4 space-y-3 bg-gray-50">
        <div class="flex justify-between">
          <div class="font-normal text-base text-gray-500">Appointment fee</div>
          <div class="font-medium text-base text-gray-900">
            {{ data.servicesCost | currency: 'USD' }}
          </div>
        </div>
        @if (taxAmountDollars() !== null) {
          <div class="flex justify-between">
            <div class="font-normal text-base text-gray-500">{{ taxLabel() }}</div>
            <div class="font-medium text-base text-gray-900">
              {{ taxAmountDollars() | currency: 'USD' }}
            </div>
          </div>
        }
        <div class="flex justify-between">
          <div class="font-normal text-base text-gray-500">Charge today</div>
          <div class="font-medium text-base text-gray-900">
            {{ 0 | currency: 'USD' }}
          </div>
        </div>
      </div>

      <button
        (click)="submit()"
        class="w-full text-white bg-primary-700 enabled:hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:bg-gray-100 disabled:text-gray-500 cursor-pointer">
        @if (submitting()) {
          <icaredx-spinner size="small"></icaredx-spinner>
        } @else {
          <span>Continue to secure setup</span>
        }
      </button>
      <button
        type="button"
        (click)="cancelBooking()"
        class="w-full text-red-700 bg-white border border-red-300 hover:bg-red-50 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center cursor-pointer">
        Cancel booking
      </button>
      <div class="font-medium text-sm text-gray-500">
        By continuing, you agree to iCareDx’s
        <button
          class="inline text-primary-700 cursor-pointer underline hover:text-primary-800"
          (click)="openDisclaimer('privacyPolicy')">
          privacy note
        </button>
        and
        <button
          class="inline text-primary-700 cursor-pointer underline hover:text-primary-800"
          (click)="openDisclaimer('termsOfService')">
          terms of use</button
        >.
      </div>
    </div>
  </div>
</div>